// extracted by mini-css-extract-plugin
module.exports = {"button-container":"styles_button-container__XNQU2","logo-container":"styles_logo-container__17qvk","button-text":"styles_button-text__2xpWc"};